import axios from "@/axios";

export const namespaced = true;

export const state = {
  theaters: [],
  theater: null,
};

export const getters = {
  allTheaters: (state) => state.theaters,
  paginatedOperationTheaters: (state) => state.theaters,
  theater: (state) => state.theater,
};

export const mutations = {
  SET_THEATERS: (state, resp) => (state.theaters = resp.data),
  SET_THEATER: (state, resp) => (state.theater = resp.data),
};

export const actions = {
  async getTheaters({ commit }) {
    commit("SET_THEATERS", await axios.get("/api/theaters"));
  },
  async getTheater({ commit }, id) {
    commit("SET_THEATER", await axios.get(`/api/theaters/${id}`));
  },
  async saveTheater({ commit, dispatch }, data) {
    return await axios.post("/api/theaters", data).then(({ data }) => {
      dispatch("getTheaters");
    });
  },
  async searchTheater({ commit }, term) {
    return await axios.get(``).then((data) => {
      commit("SET_THEATERS", data);
    });
  },
  async deleteTheater({ dispatch }, id) {
    return await axios.delete(`/api/theaters/${id}`).then(({ data }) => {
      dispatch("getTheaters");
    });
  },
};
